module.exports = __webpack_public_path__ + "img/DE00039.19e460e3.png";